import * as api from '../resources/manage-inventory.api';
import actionTypes from './action-types';

export const fetchLiabilitiesRequest = () => ({
  type: actionTypes.FETCH_LIABILITIES_REQUEST,
  name: 'manageInventoryLoadingStatus',
});

export const fetchLiabilitiesSuccess = (liabilities, pagination) => ({
  type: actionTypes.FETCH_LIABILITIES_SUCCESS,
  name: 'manageInventoryLoadingStatus',
  pagination,
  liabilities,
});

export const fetchLiabilitiesFailure = () => ({
  type: actionTypes.FETCH_LIABILITIES_FAILURE,
  name: 'manageInventoryLoadingStatus',
});

export const fetchLiabilities = (config = {}) => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const { locale } = session;
    const retailerId = config.retailerId || session.retailer.retailerId;

    const requestParams = {
      ...config,
      locale,
      retailerId,
    };

    dispatch(fetchLiabilitiesRequest());

    const { content: liabilities, ...pagination } = await api.fetchLiabilities(requestParams);
    dispatch(fetchLiabilitiesSuccess(liabilities, pagination));
  } catch (error) {
    console.error('FETCH_LIABILITIES', error);
    dispatch(fetchLiabilitiesFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/actions/fetch-liabilities.actions.js